module.exports = __webpack_public_path__ + "static/media/caffe-milano-1.f17dfcd2.jpg";